import { render, staticRenderFns } from "./GetinModal.vue?vue&type=template&id=37d7356d&scoped=true&"
import script from "./GetinModal.vue?vue&type=script&lang=ts&"
export * from "./GetinModal.vue?vue&type=script&lang=ts&"
import style0 from "./GetinModal.vue?vue&type=style&index=0&id=37d7356d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d7356d",
  null
  
)

export default component.exports